import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Footer from "../../components/Footers/Footer";
import welcomeImage from "../../assets/img/2150902411.jpg";

const Login = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [formData, setFormData] = useState({ email: "", mdp: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.mdp) {
      setNotification({ type: "error", message: "Tous les champs sont obligatoires" });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post("https://appapi.unpaidfinancial.com/api/login", formData);
      const { refresh, access, message, role, userId } = response.data;

      localStorage.setItem("accessToken", access);
      localStorage.setItem("refreshToken", refresh);
      localStorage.setItem("role", role);

      if (role === "client") localStorage.setItem("clientId", userId);
      else if (role === "admin") localStorage.setItem("adminId", userId);

      setNotification({ type: "success", message });

      setTimeout(() => {
        if (role === "client") history.push("/me");
        else if (role === "admin") history.push("/admin/dashboard/");
        else {
          setNotification({ type: "error", message: "Rôle inconnu, contactez l'administrateur." });
        }
      }, 1200);
    } catch {
      setNotification({ type: "error", message: "Email ou mot de passe incorrect" });
    } finally {
      setLoading(false);
    }
  };

  // ✅ On garde ton fond tel quel (container + imageSection)
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "calc(100vh - 80px)",
    padding: "2rem",
    backgroundColor: "#1e293b",
    marginTop: "80px",
    paddingBottom: "6rem",
  };

  const cardStyle = {
    display: "flex",
    width: "100%",
    maxWidth: "1000px",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 22px 55px rgba(0,0,0,0.25)",
    flexDirection: isMobile ? "column" : "row",
    background: "transparent",
  };

  const imageSectionStyle = {
    flex: 1,
    background: `linear-gradient(rgba(79, 70, 229, 0.7), rgba(124, 58, 237, 0.8)), url(${welcomeImage}) center/cover no-repeat`,
    padding: "2rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    minHeight: isMobile ? "280px" : "520px",
  };

  // ✅ Ici on applique le style “Register (soft SaaS)” : pas blanc agressif, plus doux, lisible
  const formSectionStyle = {
    flex: 1,
    background: "rgba(255,255,255,0.92)",
    padding: isMobile ? "2rem 1.5rem" : "3rem",
    display: "flex",
    flexDirection: "column",
    borderLeft: isMobile ? "none" : "1px solid rgba(255,255,255,0.10)",
  };

  const titleStyle = {
    textAlign: "center",
    marginBottom: "1.5rem",
    fontSize: "1.35rem",
    fontWeight: 750,
    color: "#0f172a",
    letterSpacing: "-0.02em",
  };

  const subTitleStyle = {
    textAlign: "center",
    marginTop: "-0.75rem",
    marginBottom: "1.75rem",
    fontSize: "0.95rem",
    color: "#64748b",
    lineHeight: 1.5,
  };

  const fieldStyle = { marginBottom: "1.1rem" };

  const labelStyle = {
    display: "block",
    marginBottom: "0.45rem",
    color: "#64748b",
    fontWeight: 600,
    fontSize: "0.9rem",
  };

  const inputStyle = {
    width: "100%",
    padding: "0.78rem 0.95rem",
    border: "1px solid #dbe3ef",
    borderRadius: "12px",
    backgroundColor: "rgba(248,250,252,0.95)",
    color: "#0f172a",
    fontSize: "1rem",
    outline: "none",
    transition: "border-color 0.18s, box-shadow 0.18s, transform 0.18s, background-color 0.18s",
  };

  const inputFocus = (e) => {
    e.target.style.borderColor = "rgba(37,99,235,.55)";
    e.target.style.boxShadow = "0 0 0 4px rgba(37,99,235,.12)";
    e.target.style.transform = "translateY(-1px)";
    e.target.style.backgroundColor = "#ffffff";
  };

  const inputBlur = (e) => {
    e.target.style.borderColor = "#dbe3ef";
    e.target.style.boxShadow = "none";
    e.target.style.transform = "translateY(0px)";
    e.target.style.backgroundColor = "rgba(248,250,252,0.95)";
  };

  const buttonStyle = {
    width: "100%",
    padding: "0.85rem",
    background: loading ? "rgba(37,99,235,.75)" : "#2563eb",
    color: "white",
    borderRadius: "14px",
    fontWeight: 750,
    cursor: loading ? "not-allowed" : "pointer",
    border: "none",
    fontSize: "1rem",
    marginTop: "0.35rem",
    opacity: loading ? 0.92 : 1,
    transition: "transform 0.15s, background-color 0.2s, box-shadow 0.2s",
    boxShadow: "0 12px 24px rgba(37,99,235,.18)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.6rem",
  };

  const buttonHover = (e) => {
    if (loading) return;
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.background = "#1d4ed8";
    e.currentTarget.style.boxShadow = "0 16px 32px rgba(37,99,235,.22)";
  };

  const buttonLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0px)";
    e.currentTarget.style.background = loading ? "rgba(37,99,235,.75)" : "#2563eb";
    e.currentTarget.style.boxShadow = "0 12px 24px rgba(37,99,235,.18)";
  };

  const footerLinkStyle = {
    textAlign: "center",
    marginTop: "1.35rem",
    color: "#64748b",
    fontSize: "0.95rem",
    lineHeight: 1.7,
  };

  const linkStyle = {
    color: "#2563eb",
    textDecoration: "none",
    fontWeight: 750,
  };

  const notificationStyle = {
    padding: "0.75rem 1rem",
    borderRadius: "12px",
    marginBottom: "1rem",
    textAlign: "center",
    color: "#0f172a",
    fontWeight: 650,
    fontSize: "0.95rem",
    border: "1px solid #dbe3ef",
    background: "rgba(248,250,252,0.85)",
  };

  const welcomeTextStyle = {
    color: "white",
    textAlign: "center",
    padding: "2.1rem",
    position: "relative",
    zIndex: 1,
    maxWidth: "600px",
    backgroundColor: "rgba(0, 0, 0, 0.45)",
    borderRadius: "16px",
    backdropFilter: "blur(4px)",
    boxShadow: "0 10px 28px rgba(0, 0, 0, 0.25)",
    border: "1px solid rgba(255,255,255,0.10)",
  };

  const dividerStyle = {
    height: "1px",
    width: "100%",
    background: "linear-gradient(90deg, rgba(15,23,42,0.05), rgba(15,23,42,0.12), rgba(15,23,42,0.05))",
    margin: "0.2rem 0 1.25rem",
  };

  const iconBtnStyle = {
    position: "absolute",
    top: "50%",
    right: "0.85rem",
    transform: "translateY(-50%)",
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#64748b",
    background: "rgba(15,23,42,0.03)",
    border: "1px solid #dbe3ef",
    transition: "background-color 0.15s, transform 0.15s",
    userSelect: "none",
  };

  const iconBtnHover = (e) => {
    e.currentTarget.style.background = "rgba(15,23,42,0.06)";
    e.currentTarget.style.transform = "translateY(-50%) scale(1.02)";
  };

  const iconBtnLeave = (e) => {
    e.currentTarget.style.background = "rgba(15,23,42,0.03)";
    e.currentTarget.style.transform = "translateY(-50%) scale(1)";
  };

  return (
    <>
      <div style={containerStyle}>
        <div style={cardStyle}>
          {/* ✅ Image section : inchangée */}
          <div style={imageSectionStyle}>
            <div style={welcomeTextStyle}>
              <h2
                style={{
                  fontSize: "1.85rem",
                  fontWeight: 800,
                  marginBottom: "0.8rem",
                  textAlign: "center",
                  letterSpacing: "-0.02em",
                }}
              >
                Bienvenue
              </h2>
              <p
                style={{
                  fontSize: "1rem",
                  opacity: 0.92,
                  maxWidth: "420px",
                  lineHeight: "1.55",
                  textAlign: "center",
                  margin: 0,
                }}
              >
                Connectez-vous pour accéder à votre espace personnel et gérer vos demandes de financement.
              </p>
            </div>
          </div>

          {/* ✅ Form section : style aligné sur Register (soft SaaS, pas agressif) */}
          <div style={formSectionStyle}>
            <h2 style={titleStyle}>Connexion</h2>
            <p style={subTitleStyle}>Entrez vos identifiants pour accéder à votre espace.</p>
            <div style={dividerStyle} />

            {notification && (
              <div
                style={{
                  ...notificationStyle,
                  borderColor: notification.type === "success" ? "rgba(16,185,129,.35)" : "rgba(239,68,68,.30)",
                  background:
                    notification.type === "success"
                      ? "rgba(16,185,129,.08)"
                      : "rgba(239,68,68,.08)",
                  color: notification.type === "success" ? "#065f46" : "#7f1d1d",
                }}
              >
                {notification.message}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={fieldStyle}>
                <label htmlFor="email" style={labelStyle}>
                  Adresse Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  style={inputStyle}
                  placeholder="votre@email.com"
                  onFocus={inputFocus}
                  onBlur={inputBlur}
                  autoComplete="email"
                  inputMode="email"
                />
              </div>

              <div style={fieldStyle}>
                <label htmlFor="mdp" style={labelStyle}>
                  Mot de passe
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="mdp"
                    name="mdp"
                    value={formData.mdp}
                    onChange={handleChange}
                    style={{ ...inputStyle, paddingRight: "3.2rem" }}
                    placeholder="••••••••"
                    onFocus={inputFocus}
                    onBlur={inputBlur}
                    autoComplete="current-password"
                  />

                  <span
                    onClick={() => setShowPassword((v) => !v)}
                    style={iconBtnStyle}
                    onMouseEnter={iconBtnHover}
                    onMouseLeave={iconBtnLeave}
                    title={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                    role="button"
                    tabIndex={0}
                  >
                    <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                  </span>
                </div>
              </div>

              <button
                type="submit"
                style={buttonStyle}
                disabled={loading}
                onMouseEnter={buttonHover}
                onMouseLeave={buttonLeave}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin" />
                    Connexion...
                  </>
                ) : (
                  "Se connecter"
                )}
              </button>
            </form>

            <div style={footerLinkStyle}>
              <p style={{ margin: "0.9rem 0 0" }}>
                Pas encore de compte ? <a href="/demande" style={linkStyle}>Ouvrir une demande</a>
              </p>
              <p style={{ margin: "0.2rem 0 0" }}>
                <a href="/forgot" style={linkStyle}>Mot de passe oublié ?</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Login;
